import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "lot-detail-modal__container" }
const _hoisted_2 = { class: "lot-detail-modal__body" }
const _hoisted_3 = { class: "lot-detail-modal__image-panel" }
const _hoisted_4 = { class: "lot-detail-modal__image-wrap" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 1,
  class: "lot-detail-modal__image-placeholder"
}
const _hoisted_7 = { class: "lot-detail-modal__image-overlay" }
const _hoisted_8 = {
  key: 0,
  class: "lot-detail-modal__design-title"
}
const _hoisted_9 = {
  key: 1,
  class: "lot-detail-modal__design-facade"
}
const _hoisted_10 = {
  key: 2,
  class: "lot-detail-modal__overlay-specs"
}
const _hoisted_11 = {
  key: 0,
  class: "overlay-spec"
}
const _hoisted_12 = {
  key: 1,
  class: "overlay-spec"
}
const _hoisted_13 = {
  key: 2,
  class: "overlay-spec"
}
const _hoisted_14 = {
  key: 3,
  class: "overlay-spec"
}
const _hoisted_15 = { class: "lot-detail-modal__lot-badge" }
const _hoisted_16 = { class: "lot-badge-title" }
const _hoisted_17 = { class: "lot-detail-modal__details-panel" }
const _hoisted_18 = { class: "lot-detail-modal__tabs" }
const _hoisted_19 = {
  key: 0,
  class: "lot-detail-modal__tab-content"
}
const _hoisted_20 = { class: "lot-detail-modal__pills-row" }
const _hoisted_21 = {
  key: 0,
  class: "lot-detail-modal__pill-group"
}
const _hoisted_22 = { class: "lot-detail-modal__pill" }
const _hoisted_23 = { class: "lot-detail-modal__pill-group" }
const _hoisted_24 = { class: "lot-detail-modal__pill" }
const _hoisted_25 = {
  key: 1,
  class: "lot-detail-modal__pill-group"
}
const _hoisted_26 = { class: "lot-detail-modal__pill" }
const _hoisted_27 = {
  key: 2,
  class: "lot-detail-modal__pill-group"
}
const _hoisted_28 = { class: "lot-detail-modal__pill" }
const _hoisted_29 = { class: "lot-detail-modal__home-design" }
const _hoisted_30 = { class: "home-design-count" }
const _hoisted_31 = { class: "lot-detail-modal__design-cards" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "design-card__name" }
const _hoisted_34 = {
  key: 0,
  class: "design-card__facade"
}
const _hoisted_35 = {
  key: 1,
  class: "design-card__size"
}
const _hoisted_36 = { class: "design-card__specs" }
const _hoisted_37 = {
  key: 0,
  class: "design-card__spec"
}
const _hoisted_38 = {
  key: 1,
  class: "design-card__spec"
}
const _hoisted_39 = {
  key: 2,
  class: "design-card__spec"
}
const _hoisted_40 = {
  key: 2,
  class: "design-card__price"
}
const _hoisted_41 = { class: "lot-detail-modal__design-rows" }
const _hoisted_42 = { class: "lot-detail-modal__design-row" }
const _hoisted_43 = { class: "design-row__value" }
const _hoisted_44 = {
  key: 0,
  class: "lot-detail-modal__design-row"
}
const _hoisted_45 = { class: "design-row__value" }
const _hoisted_46 = { class: "lot-detail-modal__specs-chips" }
const _hoisted_47 = {
  key: 0,
  class: "spec-chip"
}
const _hoisted_48 = {
  key: 1,
  class: "spec-chip"
}
const _hoisted_49 = {
  key: 2,
  class: "spec-chip"
}
const _hoisted_50 = {
  key: 3,
  class: "spec-chip"
}
const _hoisted_51 = { class: "lot-detail-modal__highlights-pills" }
const _hoisted_52 = {
  key: 1,
  class: "lot-detail-modal__tab-content floor-plan-content"
}
const _hoisted_53 = ["src"]
const _hoisted_54 = {
  key: 2,
  class: "lot-detail-modal__no-content"
}
const _hoisted_55 = {
  key: 2,
  class: "lot-detail-modal__tab-content documents-content"
}
const _hoisted_56 = { class: "lot-detail-modal__documents-count" }
const _hoisted_57 = {
  key: 0,
  class: "lot-detail-modal__documents-list"
}
const _hoisted_58 = ["onClick", "onKeydown"]
const _hoisted_59 = { class: "lot-detail-modal__document-icon" }
const _hoisted_60 = { class: "lot-detail-modal__document-info" }
const _hoisted_61 = { class: "lot-detail-modal__document-name" }
const _hoisted_62 = { class: "lot-detail-modal__document-date" }
const _hoisted_63 = ["aria-label", "onClick"]
const _hoisted_64 = {
  key: 1,
  class: "lot-detail-modal__no-content"
}
const _hoisted_65 = { class: "lot-detail-modal__footer" }
const _hoisted_66 = {
  key: 0,
  class: "lot-detail-modal__total-price-row"
}
const _hoisted_67 = { class: "total-price" }
const _hoisted_68 = { class: "lot-detail-modal__actions" }
const _hoisted_69 = ["disabled"]
const _hoisted_70 = {
  key: 1,
  class: "lot-detail-modal__enquiry-form"
}
const _hoisted_71 = { class: "lot-detail-modal__enquiry-header" }
const _hoisted_72 = { class: "enquiry-title-row" }
const _hoisted_73 = { class: "lot-detail-modal__enquiry-subtitle" }
const _hoisted_74 = {
  key: 0,
  class: "lot-detail-modal__enquiry-notice"
}
const _hoisted_75 = { class: "lot-detail-modal__enquiry-fields" }
const _hoisted_76 = { class: "lot-detail-modal__enquiry-field" }
const _hoisted_77 = {
  key: 0,
  class: "lot-detail-modal__enquiry-error"
}
const _hoisted_78 = { class: "lot-detail-modal__enquiry-field" }
const _hoisted_79 = {
  key: 0,
  class: "lot-detail-modal__enquiry-error"
}
const _hoisted_80 = { class: "lot-detail-modal__enquiry-field" }
const _hoisted_81 = {
  key: 0,
  class: "lot-detail-modal__enquiry-error"
}
const _hoisted_82 = { class: "lot-detail-modal__enquiry-field" }
const _hoisted_83 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      name: "lot-modal-fade",
      appear: ""
    }, {
      default: _withCtx(() => [
        ($props.isOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "lot-detail-modal",
              onTouchmove: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["self","prevent"]))
            }, [
              _createElementVNode("div", {
                class: "lot-detail-modal__backdrop",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                onTouchmove: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
              }, null, 32),
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("button", {
                      class: "lot-detail-modal__image-close",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close'))),
                      "aria-label": "Close"
                    }, [
                      _createVNode($setup["X"], { size: 18 })
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                      ($setup.modalContentReady && $setup.houseImage)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "lot-detail-modal__house-img",
                            src: $setup.houseImage,
                            alt: $setup.houseDesignName || 'House design',
                            decoding: "async"
                          }, null, 8, _hoisted_5))
                        : (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[20] || (_cache[20] = [
                            _createElementVNode("div", { class: "lot-detail-modal__placeholder-icon" }, "🏠", -1)
                          ]))]))
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      ($setup.modalContentReady && $setup.displayName)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString($setup.displayName), 1))
                        : _createCommentVNode("", true),
                      ($setup.modalContentReady && $setup.facadeName)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString($setup.facadeName) + _toDisplayString($setup.facadeName && $setup.facadeName !== "Multiple Facades" ? " Facade" : ""), 1))
                        : _createCommentVNode("", true),
                      ($setup.modalContentReady && $setup.houseDesign && $setup.hasSpecs)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            ($setup.houseDesign.bedroom)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                  _createVNode($setup["Bed"], {
                                    class: "overlay-spec-icon",
                                    size: 13
                                  }),
                                  _createElementVNode("span", null, _toDisplayString($setup.houseDesign.bedroom), 1)
                                ]))
                              : _createCommentVNode("", true),
                            ($setup.bathroomCount)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                  _createVNode($setup["Bath"], {
                                    class: "overlay-spec-icon",
                                    size: 13
                                  }),
                                  _createElementVNode("span", null, _toDisplayString($setup.bathroomCount), 1)
                                ]))
                              : _createCommentVNode("", true),
                            ($setup.houseDesign.garage)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                  _createVNode($setup["Car"], {
                                    class: "overlay-spec-icon",
                                    size: 13
                                  }),
                                  _createElementVNode("span", null, _toDisplayString($setup.houseDesign.garage), 1)
                                ]))
                              : _createCommentVNode("", true),
                            ($setup.houseDesign.area)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                  _createVNode($setup["Maximize2"], {
                                    class: "overlay-spec-icon",
                                    size: 13
                                  }),
                                  _createElementVNode("span", null, _toDisplayString($setup.houseDesign.area) + "m²", 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("span", _hoisted_16, "Lot " + _toDisplayString($props.lot.lotId?.title), 1),
                        _createElementVNode("span", {
                          class: "lot-badge-status",
                          style: _normalizeStyle($setup.getMasterplanStatusBadgeStyle($props.lot.lotId?.status))
                        }, _toDisplayString($setup.lotStatusLabel), 5)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    (!$setup.showEnquiryForm)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["lot-detail-modal__tab", { active: $setup.activeTab === 'details' }]),
                              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.activeTab = 'details'))
                            }, "Lot Details", 2),
                            _createElementVNode("button", {
                              class: _normalizeClass(["lot-detail-modal__tab", { active: $setup.activeTab === 'floorplan' }]),
                              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.activeTab = 'floorplan'))
                            }, "Floor Plan", 2),
                            ($setup.lotDocuments.length)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["lot-detail-modal__tab", { active: $setup.activeTab === 'documents' }]),
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.activeTab = 'documents'))
                                }, "Documents", 2))
                              : _createCommentVNode("", true),
                            _createElementVNode("button", {
                              class: "lot-detail-modal__tab-close",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('close'))),
                              "aria-label": "Close"
                            }, [
                              _createVNode($setup["X"], { size: 16 })
                            ])
                          ]),
                          ($setup.activeTab === 'details')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, [
                                  ($setup.stageTitle !== '—')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                        _cache[21] || (_cache[21] = _createElementVNode("span", { class: "pill-label" }, "Release", -1)),
                                        _createElementVNode("span", _hoisted_22, [
                                          _createVNode($setup["Layers"], {
                                            class: "pill-icon",
                                            size: 14
                                          }),
                                          _createElementVNode("span", null, "Stage " + _toDisplayString($setup.stageTitle), 1)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_23, [
                                    _cache[22] || (_cache[22] = _createElementVNode("span", { class: "pill-label" }, "Lot Size", -1)),
                                    _createElementVNode("span", _hoisted_24, [
                                      _createVNode($setup["Maximize2"], {
                                        class: "pill-icon",
                                        size: 14
                                      }),
                                      _createElementVNode("span", null, _toDisplayString($props.lot.lotId?.size) + " m²", 1)
                                    ])
                                  ]),
                                  ($props.lot.lotId?.blockWidth)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                        _cache[23] || (_cache[23] = _createElementVNode("span", { class: "pill-label" }, "Lot Width", -1)),
                                        _createElementVNode("span", _hoisted_26, [
                                          _createVNode($setup["MoveHorizontal"], {
                                            class: "pill-icon",
                                            size: 14
                                          }),
                                          _createElementVNode("span", null, _toDisplayString($props.lot.lotId.blockWidth) + " m", 1)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  ($props.lot.lotId?.aspect)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                        _cache[24] || (_cache[24] = _createElementVNode("span", { class: "pill-label" }, "Aspect", -1)),
                                        _createElementVNode("span", _hoisted_28, [
                                          _createVNode($setup["Navigation"], {
                                            class: "pill-icon",
                                            size: 14
                                          }),
                                          _createElementVNode("span", null, _toDisplayString($props.lot.lotId?.aspect), 1)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                ($setup.modalContentReady && $setup.houseDesigns.length > 0)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _cache[33] || (_cache[33] = _createElementVNode("hr", { class: "lot-detail-modal__section-divider" }, null, -1)),
                                      _createElementVNode("div", _hoisted_29, [
                                        _cache[32] || (_cache[32] = _createElementVNode("p", { class: "section-heading" }, "HOME DESIGN", -1)),
                                        ($setup.houseDesigns.length > 1)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createElementVNode("p", _hoisted_30, _toDisplayString($setup.houseDesigns.length) + " home designs available on this lot", 1),
                                              _createElementVNode("div", _hoisted_31, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.houseDesigns, (design, i) => {
                                                  return (_openBlock(), _createElementBlock("button", {
                                                    class: _normalizeClass(["lot-detail-modal__design-card", { active: $setup.selectedDesignIndex === i }]),
                                                    key: design._id ?? i,
                                                    onClick: ($event: any) => ($setup.selectedDesignIndex = i)
                                                  }, [
                                                    _createElementVNode("p", _hoisted_33, _toDisplayString(design.name), 1),
                                                    ($setup.getDesignFacadeLabel(design))
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString($setup.getDesignFacadeLabel(design)), 1))
                                                      : _createCommentVNode("", true),
                                                    (design.area)
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(design.area) + " m²", 1))
                                                      : _createCommentVNode("", true),
                                                    _createElementVNode("div", _hoisted_36, [
                                                      (design.bedroom)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                                            _createVNode($setup["Bed"], {
                                                              class: "spec-chip-icon",
                                                              size: 13
                                                            }),
                                                            _createElementVNode("span", null, _toDisplayString(design.bedroom), 1)
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                      ($setup.getDesignBathroomCount(design))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                                            _createVNode($setup["Bath"], {
                                                              class: "spec-chip-icon",
                                                              size: 13
                                                            }),
                                                            _createElementVNode("span", null, _toDisplayString($setup.getDesignBathroomCount(design)), 1)
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                      (design.garage)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                                            _createVNode($setup["Car"], {
                                                              class: "spec-chip-icon",
                                                              size: 13
                                                            }),
                                                            _createElementVNode("span", null, _toDisplayString(design.garage), 1)
                                                          ]))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    (design.basePrice && !$setup.lotData.hidePrice)
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_40, "from " + _toDisplayString($setup.formatDesignPrice(design)), 1))
                                                      : _createCommentVNode("", true)
                                                  ], 10, _hoisted_32))
                                                }), 128))
                                              ])
                                            ], 64))
                                          : ($setup.houseDesign)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createElementVNode("div", _hoisted_41, [
                                                  _createElementVNode("div", _hoisted_42, [
                                                    _cache[25] || (_cache[25] = _createElementVNode("span", { class: "design-row__label" }, "Design", -1)),
                                                    _createElementVNode("span", _hoisted_43, _toDisplayString($setup.houseDesignName), 1)
                                                  ]),
                                                  ($setup.facadeName)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                                        _cache[26] || (_cache[26] = _createElementVNode("span", { class: "design-row__label" }, "Facade", -1)),
                                                        _createElementVNode("span", _hoisted_45, _toDisplayString($setup.facadeName), 1)
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("div", _hoisted_46, [
                                                  ($setup.houseDesign.bedroom)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                                        _createVNode($setup["Bed"], {
                                                          class: "spec-chip-icon",
                                                          size: 16
                                                        }),
                                                        _createElementVNode("span", null, _toDisplayString($setup.houseDesign.bedroom), 1),
                                                        _cache[27] || (_cache[27] = _createElementVNode("span", { class: "spec-chip-label" }, "Bed", -1))
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  ($setup.bathroomCount)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                                        _createVNode($setup["Bath"], {
                                                          class: "spec-chip-icon",
                                                          size: 16
                                                        }),
                                                        _createElementVNode("span", null, _toDisplayString($setup.bathroomCount), 1),
                                                        _cache[28] || (_cache[28] = _createElementVNode("span", { class: "spec-chip-label" }, "Bath", -1))
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  ($setup.houseDesign.garage)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                                        _createVNode($setup["Car"], {
                                                          class: "spec-chip-icon",
                                                          size: 16
                                                        }),
                                                        _createElementVNode("span", null, _toDisplayString($setup.houseDesign.garage), 1),
                                                        _cache[29] || (_cache[29] = _createElementVNode("span", { class: "spec-chip-label" }, "Garage", -1))
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  ($setup.houseDesign.area)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                                        _createVNode($setup["Maximize2"], {
                                                          class: "spec-chip-icon",
                                                          size: 16
                                                        }),
                                                        _createElementVNode("span", null, _toDisplayString($setup.houseDesign.area) + " m²", 1)
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ], 64))
                                            : _createCommentVNode("", true),
                                        ($setup.houseDesign && $setup.houseDesign.features && $setup.houseDesign.features.length)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                              _cache[30] || (_cache[30] = _createElementVNode("hr", { class: "lot-detail-modal__section-divider" }, null, -1)),
                                              _cache[31] || (_cache[31] = _createElementVNode("p", { class: "section-heading highlights-section" }, "HIGHLIGHTS", -1)),
                                              _createElementVNode("div", _hoisted_51, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.houseDesign.features, (feat) => {
                                                  return (_openBlock(), _createElementBlock("span", {
                                                    class: "highlight-pill",
                                                    key: feat
                                                  }, _toDisplayString(feat), 1))
                                                }), 128))
                                              ])
                                            ], 64))
                                          : _createCommentVNode("", true)
                                      ])
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          ($setup.activeTab === 'floorplan')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                ($setup.floorPlanImage)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "lot-detail-modal__floor-plan-wrap",
                                      onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.showLightbox = true))
                                    }, [
                                      _createElementVNode("img", {
                                        class: "lot-detail-modal__floor-plan-img",
                                        src: $setup.floorPlanImage,
                                        alt: "Floor plan",
                                        decoding: "async"
                                      }, null, 8, _hoisted_53)
                                    ]))
                                  : _createCommentVNode("", true),
                                ($setup.floorPlanImage)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: "lot-detail-modal__floor-plan-hint",
                                      onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.showLightbox = true))
                                    }, [...(_cache[34] || (_cache[34] = [
                                      _createElementVNode("span", { class: "floor-plan-hint__desktop" }, "Click to view fullscreen", -1),
                                      _createElementVNode("span", { class: "floor-plan-hint__mobile" }, "Press to view fullscreen", -1)
                                    ]))]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_54, [...(_cache[35] || (_cache[35] = [
                                      _createElementVNode("p", null, "No floor plan available for this lot.", -1)
                                    ]))]))
                              ]))
                            : _createCommentVNode("", true),
                          ($setup.activeTab === 'documents')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                _createElementVNode("p", _hoisted_56, _toDisplayString($setup.documentCountLabel), 1),
                                ($setup.lotDocuments.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lotDocuments, (document) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          class: "lot-detail-modal__document-row",
                                          key: document.fileName,
                                          role: "link",
                                          tabindex: "0",
                                          onClick: ($event: any) => ($setup.openDocument(document.link)),
                                          onKeydown: _withKeys(($event: any) => ($setup.openDocument(document.link)), ["enter"])
                                        }, [
                                          _createElementVNode("div", _hoisted_59, [
                                            _createVNode($setup["FileText"], { size: 22 })
                                          ]),
                                          _createElementVNode("div", _hoisted_60, [
                                            _createElementVNode("p", _hoisted_61, _toDisplayString($setup.getDocumentName(document.fileName)), 1),
                                            _createElementVNode("p", _hoisted_62, _toDisplayString($setup.formatDate(document.modifiedDate)), 1)
                                          ]),
                                          _createElementVNode("button", {
                                            class: "lot-detail-modal__document-download",
                                            type: "button",
                                            "aria-label": `Download ${$setup.getDocumentName(document.fileName)}`,
                                            onClick: _withModifiers(($event: any) => ($setup.downloadDocument(document)), ["stop"])
                                          }, [
                                            _createVNode($setup["Download"], { size: 18 })
                                          ], 8, _hoisted_63)
                                        ], 40, _hoisted_58))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_64, [...(_cache[36] || (_cache[36] = [
                                      _createElementVNode("p", null, "No documents available for this lot.", -1)
                                    ]))]))
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_65, [
                            ($setup.priceDisplay)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                  _cache[37] || (_cache[37] = _createElementVNode("div", { class: "total-label-group" }, [
                                    _createElementVNode("span", { class: "total-label" }, "Total Price"),
                                    _createElementVNode("span", { class: "total-sub" }, "Includes Home & Land")
                                  ], -1)),
                                  _createElementVNode("span", _hoisted_67, "from " + _toDisplayString($setup.priceDisplay), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_68, [
                              ($setup.houseDesign)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "button default primary select-lot-btn",
                                    onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.isLotAvailable && _ctx.$emit('select', $props.lot, $setup.houseDesign, $setup.assignedFacade))),
                                    disabled: !$setup.isLotAvailable
                                  }, _toDisplayString($setup.primaryCtaLabel), 9, _hoisted_69))
                                : _createCommentVNode("", true),
                              _createElementVNode("button", {
                                class: "button default outlined enquiry-btn",
                                onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.showEnquiryForm = true))
                              }, [
                                _createVNode($setup["Send"], {
                                  size: 14,
                                  style: {"flex-shrink":"0"}
                                }),
                                _cache[38] || (_cache[38] = _createElementVNode("span", null, "Submit Enquiry", -1))
                              ])
                            ])
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock("div", _hoisted_70, [
                          _createElementVNode("div", _hoisted_71, [
                            _createElementVNode("div", _hoisted_72, [
                              _createElementVNode("button", {
                                class: "enquiry-title-back",
                                onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.showEnquiryForm = false)),
                                "aria-label": "Back to lot details",
                                type: "button"
                              }, [
                                _createVNode($setup["ArrowLeft"], { size: 18 })
                              ]),
                              _cache[39] || (_cache[39] = _createElementVNode("h3", { class: "lot-detail-modal__enquiry-title" }, "Submit Enquiry", -1))
                            ]),
                            _createElementVNode("p", _hoisted_73, [
                              _createTextVNode("Lot " + _toDisplayString($props.lot.lotId?.title), 1),
                              ($setup.houseDesignName)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode("· " + _toDisplayString($setup.houseDesignName), 1)
                                  ], 64))
                                : _createCommentVNode("", true),
                              ($setup.facadeName)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode("· " + _toDisplayString($setup.facadeName), 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          (!$setup.isLotAvailable)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_74, [...(_cache[40] || (_cache[40] = [
                                _createElementVNode("p", null, "Can't find what you're looking for? Contact our sales team for more information on future releases.", -1)
                              ]))]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_75, [
                            _createElementVNode("div", _hoisted_76, [
                              _cache[41] || (_cache[41] = _createElementVNode("label", { class: "lot-detail-modal__enquiry-label" }, [
                                _createTextVNode("Full Name"),
                                _createElementVNode("span", { class: "lot-detail-modal__enquiry-required" }, "*")
                              ], -1)),
                              _withDirectives(_createElementVNode("input", {
                                class: _normalizeClass(["lot-detail-modal__enquiry-input", { 'input--error': $setup.enquiryErrors.fullName }]),
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.enquiryForm.fullName) = $event)),
                                placeholder: "Enter your full name"
                              }, null, 2), [
                                [_vModelText, $setup.enquiryForm.fullName]
                              ]),
                              ($setup.enquiryErrors.fullName)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_77, _toDisplayString($setup.enquiryErrors.fullName), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_78, [
                              _cache[42] || (_cache[42] = _createElementVNode("label", { class: "lot-detail-modal__enquiry-label" }, [
                                _createTextVNode("Email"),
                                _createElementVNode("span", { class: "lot-detail-modal__enquiry-required" }, "*")
                              ], -1)),
                              _withDirectives(_createElementVNode("input", {
                                class: _normalizeClass(["lot-detail-modal__enquiry-input", { 'input--error': $setup.enquiryErrors.email }]),
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.enquiryForm.email) = $event)),
                                type: "email",
                                placeholder: "you@example.com"
                              }, null, 2), [
                                [_vModelText, $setup.enquiryForm.email]
                              ]),
                              ($setup.enquiryErrors.email)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_79, _toDisplayString($setup.enquiryErrors.email), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_80, [
                              _cache[43] || (_cache[43] = _createElementVNode("label", { class: "lot-detail-modal__enquiry-label" }, [
                                _createTextVNode("Phone"),
                                _createElementVNode("span", { class: "lot-detail-modal__enquiry-required" }, "*")
                              ], -1)),
                              _withDirectives(_createElementVNode("input", {
                                class: _normalizeClass(["lot-detail-modal__enquiry-input", { 'input--error': $setup.enquiryErrors.phone }]),
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.enquiryForm.phone) = $event)),
                                type: "tel",
                                placeholder: "04XX XXX XXX"
                              }, null, 2), [
                                [_vModelText, $setup.enquiryForm.phone]
                              ]),
                              ($setup.enquiryErrors.phone)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_81, _toDisplayString($setup.enquiryErrors.phone), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_82, [
                              _cache[44] || (_cache[44] = _createElementVNode("label", { class: "lot-detail-modal__enquiry-label" }, "Message (optional)", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                class: "lot-detail-modal__enquiry-textarea",
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.enquiryForm.message) = $event)),
                                placeholder: "Any questions or comments...",
                                rows: "3"
                              }, null, 512), [
                                [_vModelText, $setup.enquiryForm.message]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", { class: "lot-detail-modal__enquiry-actions" }, [
                            _createElementVNode("button", {
                              class: "button default primary enquiry-send-btn",
                              onClick: $setup.submitEnquiry
                            }, [...(_cache[45] || (_cache[45] = [
                              _createElementVNode("span", null, "Submit Enquiry", -1)
                            ]))])
                          ])
                        ]))
                  ])
                ])
              ])
            ], 32))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "lightbox-fade" }, {
        default: _withCtx(() => [
          ($setup.showLightbox)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "lot-floorplan-lightbox",
                onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => ($setup.showLightbox = false), ["self"]))
              }, [
                _createElementVNode("button", {
                  class: "lot-floorplan-lightbox__close",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.showLightbox = false)),
                  "aria-label": "Close"
                }, "×"),
                _createElementVNode("img", {
                  class: "lot-floorplan-lightbox__img",
                  src: $setup.floorPlanImage,
                  alt: "Floor plan",
                  onClick: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["stop"]))
                }, null, 8, _hoisted_83),
                _cache[46] || (_cache[46] = _createElementVNode("p", { class: "lot-floorplan-lightbox__hint" }, "Click outside to close", -1))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ]))
}